import { connect } from 'react-redux';

/*
	small: 767px
	medium: 992px 
	large: 1200px
	extraLarge: 1750px
*/

const Conditional = ({ condition, children, render = undefined }) =>
	(condition && ((children && <>{children}</>) || (render && render()))) || // eslint-disable-line react/jsx-no-useless-fragment
	null;

const smallSelector = ({ browser: { is } }) => ({
	condition: is.small
});

const isSmallSelector = state => smallSelector(state).condition;

const Small = connect(smallSelector)(Conditional);

const mediumSelector = ({ browser: { is } }) => ({
	condition: is.medium
});

const Medium = connect(mediumSelector)(Conditional);

const lessThanLargeSelector = ({ browser: { lessThan } }) => ({
	condition: lessThan.large
});
const LessThanLarge = connect(lessThanLargeSelector)(Conditional);

const biggerSelector = ({ browser: { greaterThan } }) => ({
	condition: greaterThan.small
});
const isBiggerSelector = state => biggerSelector(state).condition;
const Bigger = connect(biggerSelector)(Conditional);

const biggerThanMediumSelector = ({ browser: { greaterThan } }) => ({
	condition: greaterThan.medium
});
const BiggerThanMedium = connect(biggerThanMediumSelector)(Conditional);
const isBiggerThanMediumSelector = state => biggerThanMediumSelector(state).condition;

const biggerThanLargeSelector = ({ browser: { greaterThan } }) => ({
	condition: greaterThan.large
});
const isBiggerThanLargeSelector = state => biggerThanLargeSelector(state).condition;

const BiggerThanLarge = connect(biggerThanLargeSelector)(Conditional);

/*
 * Could be dangerous to set this to is small in case we would
 * create an extra small bp in the future.
 */
const smallerSelector = ({ browser: { lessThan } }) => ({
	condition: lessThan.medium
});
const isSmallerSelector = state => smallerSelector(state).condition;

const Smaller = connect(smallerSelector)(Conditional);

const biggerThanExtraLargeSelector = ({ browser: { greaterThan } }) => ({
	condition: greaterThan.extraLarge
});
const isBiggerThanExtraLargeSelector = state => biggerThanExtraLargeSelector(state).condition;

const BiggerThanExtraLarge = connect(biggerThanExtraLargeSelector)(Conditional);

export {
	Small,
	Medium,
	LessThanLarge,
	Bigger,
	BiggerThanMedium,
	BiggerThanLarge,
	Smaller,
	isSmallSelector,
	isSmallerSelector,
	isBiggerSelector,
	isBiggerThanLargeSelector,
	isBiggerThanMediumSelector,
	isBiggerThanExtraLargeSelector,
	BiggerThanExtraLarge
};
